import { render, staticRenderFns } from "./pack.vue?vue&type=template&id=1d506ffa&scoped=true&"
import script from "./pack.vue?vue&type=script&lang=js&"
export * from "./pack.vue?vue&type=script&lang=js&"
import style0 from "./pack.vue?vue&type=style&index=0&id=1d506ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d506ffa",
  null
  
)

export default component.exports